<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div class="text item">
        <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="120px">
          <el-form-item label="检测机构：" prop="institutionName">
            <el-input v-model="searchForm.institutionName" placeholder="检测机构搜索" class="mt-search-width"></el-input>
            <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
            <el-button type="primary" style="margin-left: 40px;" @click="editBtn('')">添加检测报告</el-button>
          </el-form-item>
        </el-form>
        <el-table border :data="infoList">
          <el-table-column align="center" prop="id" label="ID" width="80"></el-table-column>
          <el-table-column align="center" prop="testSeqNoText" label="检测次序" width="100"></el-table-column>
          <el-table-column align="center" prop="institutionName" label="检测机构"></el-table-column>
          <el-table-column align="center" prop="summaryText" label="检测摘要" show-overflow-tooltip></el-table-column>
          <el-table-column align="center" prop="statusLabel" label="状态标签" width="100"></el-table-column>
          <el-table-column align="center" prop="testDate" label="检测日期" width="120"></el-table-column>
          <el-table-column align="center" prop="reportFileUrl" label="报告文件" width="100">
            <template slot-scope="scope">
              <el-link v-if="scope.row.reportFileUrl" type="primary" :href="scope.row.reportFileUrl" target="_blank">查看</el-link>
            </template>
          </el-table-column>
          <el-table-column align="center" label="状态" width="100">
            <template slot-scope="scope">
              {{ scope.row.status === 1 ? '启用' : '禁用' }}
            </template>
          </el-table-column>
          <el-table-column align="center" width="160" label="操作">
            <template slot-scope="scope">
              <el-button @click="editBtn(scope.row.id)" type="text" size="small">编辑</el-button>
              <el-button @click="delBtn(scope.row.id)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>

    <el-dialog :title="infoId === '' ? '添加检测报告' : '编辑检测报告'" :visible.sync="editShow" width="720px">
      <el-form ref="editFormRef" :model="editForm" :rules="editRules" label-width="120px">
        <el-form-item label="检测机构：" prop="institutionName">
          <el-input v-model="editForm.institutionName" placeholder="请输入检测机构"></el-input>
        </el-form-item>
        <el-form-item label="检测摘要：" prop="summaryText">
          <el-input v-model="editForm.summaryText" type="textarea" rows="3" placeholder="请输入检测摘要"></el-input>
        </el-form-item>
        <el-form-item label="检测日期：" prop="testDate">
          <el-date-picker v-model="editForm.testDate" type="date" value-format="yyyy-MM-dd" placeholder="选择检测日期" @change="handleTestDateChange"></el-date-picker>
        </el-form-item>
        <el-form-item label="状态标签：" prop="statusLabel">
          <el-input v-model="editForm.statusLabel" placeholder="留空则按检测日期自动显示「本月」或对应月份"></el-input>
        </el-form-item>
        <el-form-item label="报告文件：" prop="reportFileUrl">
          <el-upload
            :action="baseUrl + '/system/common/upload/uploadFile'"
            :headers="uploadHeaders()"
            :limit="1"
            :file-list="fileList"
            :on-remove="delFileBtn"
            :on-success="uploadSuccessBtn">
            <el-button size="small" type="primary">上传报告</el-button>
            <div slot="tip" class="el-upload__tip">支持 PDF 或图片</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="是否启用：">
          <el-switch v-model="editForm.status" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="排序：">
          <el-input v-model="editForm.sort" placeholder="数字越大越靠前"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveEditBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  queryGoodsInspectionReportPageList,
  fetchGoodsInspectionReportDetailById,
  saveGoodsInspectionReport,
  updateGoodsInspectionReport,
  removeGoodsInspectionReportById
} from '@/api/goods'
import { getUploadHeaders } from '@/utils/request'

export default {
  name: 'InspectionReportList',
  data () {
    return {
      limitLength: this.$limitLength,
      baseUrl: this.$baseUrl,
      dataId: this.$route.query.dataId,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      infoId: '',
      fullscreenLoading: false,
      editShow: false,
      searchForm: {
        institutionName: ''
      },
      editForm: {
        institutionName: '',
        summaryText: '',
        testDate: '',
        statusLabel: '',
        reportFileUrl: '',
        status: 1,
        sort: 0
      },
      fileList: [],
      editRules: {
        institutionName: [
          { required: true, message: '请输入检测机构', trigger: 'blur' }
        ],
        summaryText: [
          { required: true, message: '请输入检测摘要', trigger: 'blur' }
        ],
        testDate: [
          { required: true, message: '请选择检测日期', trigger: 'change' }
        ],
        reportFileUrl: [
          { required: true, message: '请上传报告文件', trigger: 'change' }
        ]
      }
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    uploadHeaders () {
      return getUploadHeaders()
    },
    backPage () {
      this.$router.go(-1)
    },
    searchTopBtn () {
      this.currentPage = 1
      this.getInfoList()
    },
    getInfoList () {
      queryGoodsInspectionReportPageList({
        shopGoodsId: this.dataId,
        institutionName: this.searchForm.institutionName,
        pageNum: this.currentPage,
        pageSize: this.limitLength
      }).then((res) => {
        if (res.errorCode === '0000') {
          this.infoList = res.data
          this.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          this.infoList = []
          this.pageTotal = 0
        }
      })
    },
    paginationChangeBtn (val) {
      this.currentPage = val.page
      this.getInfoList()
    },
    resetEditForm () {
      this.editForm = {
        institutionName: '',
        summaryText: '',
        testDate: '',
        statusLabel: '',
        reportFileUrl: '',
        status: 1,
        sort: 0
      }
      this.fileList = []
    },
    clearEditFormValidate () {
      this.$nextTick(() => {
        if (this.$refs.editFormRef) {
          this.$refs.editFormRef.clearValidate()
        }
      })
    },
    resolveStatusLabelByTestDate (testDate) {
      if (!testDate) {
        return ''
      }
      const date = new Date(testDate.replace(/-/g, '/'))
      if (Number.isNaN(date.getTime())) {
        return ''
      }
      const now = new Date()
      if (date.getFullYear() === now.getFullYear() && date.getMonth() === now.getMonth()) {
        return '本月'
      }
      const monthLabels = ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
      return monthLabels[date.getMonth()] || ''
    },
    fillStatusLabelIfEmpty () {
      if (this.editForm.statusLabel && this.editForm.statusLabel.trim()) {
        return
      }
      this.editForm.statusLabel = this.resolveStatusLabelByTestDate(this.editForm.testDate)
    },
    handleTestDateChange () {
      this.fillStatusLabelIfEmpty()
    },
    editBtn (id) {
      this.infoId = id || ''
      this.resetEditForm()
      if (this.infoId === '') {
        this.editShow = true
        this.clearEditFormValidate()
        return
      }
      fetchGoodsInspectionReportDetailById({ id: this.infoId }).then((res) => {
        if (res.errorCode === '0000') {
          const data = res.data
          this.editForm = {
            institutionName: data.institutionName,
            summaryText: data.summaryText,
            testDate: data.testDate,
            statusLabel: data.statusLabel,
            reportFileUrl: data.reportFileUrl,
            status: data.status,
            sort: data.sort
          }
          if (data.reportFileUrl) {
            this.fileList = [{ name: '报告文件', url: data.reportFileUrl }]
          }
          this.fillStatusLabelIfEmpty()
          this.editShow = true
          this.clearEditFormValidate()
        }
      })
    },
    uploadSuccessBtn (res) {
      if (res.errorCode === '0000') {
        this.editForm.reportFileUrl = res.data.fileUrl
        this.fileList = [{ name: '报告文件', url: res.data.fileUrl }]
        this.$nextTick(() => {
          if (this.$refs.editFormRef) {
            this.$refs.editFormRef.validateField('reportFileUrl')
          }
        })
      } else {
        this.$message.error(res.msg || '上传失败')
        this.fileList = []
        this.editForm.reportFileUrl = ''
      }
    },
    delFileBtn () {
      this.editForm.reportFileUrl = ''
      this.fileList = []
      this.$nextTick(() => {
        if (this.$refs.editFormRef) {
          this.$refs.editFormRef.validateField('reportFileUrl')
        }
      })
    },
    saveEditBtn () {
      this.$refs.editFormRef.validate((valid) => {
        if (!valid) {
          return
        }
        this.submitEditForm()
      })
    },
    submitEditForm () {
      this.fillStatusLabelIfEmpty()
      const payload = {
        ...this.editForm,
        shopGoodsId: Number(this.dataId),
        sort: Number(this.editForm.sort || 0)
      }
      this.fullscreenLoading = true
      const requestFn = this.infoId === '' ? saveGoodsInspectionReport : updateGoodsInspectionReport
      if (this.infoId !== '') {
        payload.id = Number(this.infoId)
      }
      requestFn(payload).then((res) => {
        this.fullscreenLoading = false
        if (res.errorCode === '0000') {
          this.$message.success(res.msg)
          this.editShow = false
          this.getInfoList()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    delBtn (id) {
      this.$confirm('确认删除该检测报告吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeGoodsInspectionReportById({ ids: [id] }).then((res) => {
          if (res.errorCode === '0000') {
            this.$message.success(res.msg)
            this.getInfoList()
          } else {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/goods/InspectionReportList.vue